import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import * as actions from '../../state/actions'
import { bindActionCreators } from 'redux'

class SubscriptionContainer extends Component {
    render() {
        var self = this
        const childrenWithProps = React.Children.map(self.props.children,
            (child) => React.cloneElement(child, { approved: self.props.approved, pending: self.props.pending, rejected: self.props.rejected })
        )

        return (
            <div>
                { childrenWithProps }
            </div>
        )
    }
}

SubscriptionContainer.propTypes = {
    approved: PropTypes.number,
    pending: PropTypes.number,
    rejected: PropTypes.number
}

function mapStateToProps(state) {
    return {
        subscriptions: state.subscriptions,
        routing: state.routing
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(SubscriptionContainer)



// WEBPACK FOOTER //
// ./containers/SubscriptionContainer/index.js